module.exports = __webpack_public_path__ + "assets/img/enterIcon3.4be07bd5.png";